import styles from '../styles/styles';
import configuration from '../configuration';
import zonesData from './data/zones_lulc-min.json';
import zonesCoastalData from './data/zones_coastal-min.json';
import zonesRiparianData from './data/zones_riparian-min.json';

const interferometryPoints = {
	key: 'interferometryPoints',
	type: 'vector',
	options: {
		renderAs: [
			{
				options: {
					renderingTechnique: 'canvas',
					pointAsMarker: false,
					style: styles.byKey.displacementLosAsPoints.data.definition, // todo add style later?
				},
				boxRangeRange: [1500, null],
			},
			{
				boxRangeRange: [null, 1500],
			},
		],
		pointAsMarker: true,
		features: [],
		hoverable: true,
		hovered: {
			style: 'default',
		},
		selectable: true,
		selected: {
			interferometry: {},
		},
		style: styles.byKey.displacementLosAsMarkers.data.definition,
		fidColumnName: configuration.interferometry.fidColumnName,
	},
};

const interferometryPointsSmall = {
	key: 'interferometryPointsSmall',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: [],
		style: styles.byKey.displacementLosAsPointsSmall.data.definition,
		fidColumnName: configuration.interferometry.fidColumnName,
	},
};

const interferometryZones = {
	key: 'interferometryZones',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zonesData.features,
		style: styles.byKey.zonesBase.data.definition,
		fidColumnName: configuration.zones.fidColumnName,
		hoverable: true,
		pickable: true,
		selected: {
			zones: {},
		},
	},
};

const interferometryZonesSmall = {
	key: 'interferometryZonesSmall',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zonesData.features,
		style: styles.byKey.zonesInvisible.data.definition,
		fidColumnName: configuration.zones.fidColumnName,
		selected: {
			zones: {},
		},
	},
};

const zones = {
	key: 'zones',
	type: 'vector',
	options: {
		features: zonesData.features,
		style: styles.byKey.zonesExposure.data.definition, // TODO set style later
		hoverable: true,
		pickable: true,
		hovered: {
			style: 'default',
		},
		selectable: true,
		selected: {
			zones: {},
		},
		fidColumnName: configuration.zones.fidColumnName,
	},
};

const zonesSmall = {
	key: 'zonesSmall',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zonesData.features,
		style: styles.byKey.zonesExposureSmall.data.definition, // TODO set style later
		fidColumnName: configuration.zones.fidColumnName,
		selected: {
			zones: {},
		},
	},
};

const zonesCoastal = {
	key: 'zonesCoastal',
	type: 'vector',
	options: {
		features: zonesCoastalData.features,
		renderingTechnique: 'canvas',
		style: styles.byKey.zonesExposure.data.definition, // TODO set style later
	},
};

const interferometryZonesCoastal = {
	...zonesCoastal,
	key: 'interferometryZonesCoastal',
};

const zonesCoastalSmall = {
	key: 'zonesCoastalSmall',
	type: 'vector',
	options: {
		features: zonesCoastalData.features,
		renderingTechnique: 'canvas',
		style: styles.byKey.zonesExposureSmall.data.definition, // TODO set style later
	},
};

const interferometryZonesCoastalSmall = {
	...zonesCoastalSmall,
	key: 'interferometryZonesCoastalSmall',
};

const zonesRiparian = {
	key: 'zonesRiparian',
	type: 'vector',
	options: {
		features: zonesRiparianData.features,
		renderingTechnique: 'canvas',
		style: styles.byKey.zonesExposure.data.definition, // TODO set style later
	},
};

const interferometryZonesRiparian = {
	...zonesRiparian,
	key: 'interferometryZonesRiparian',
};

const zonesRiparianSmall = {
	key: 'zonesRiparianSmall',
	type: 'vector',
	options: {
		features: zonesRiparianData.features,
		renderingTechnique: 'canvas',
		style: styles.byKey.zonesExposureSmall.data.definition, // TODO set style later
	},
};

const interferometryZonesRiparianSmall = {
	...zonesRiparianSmall,
	key: 'interferometryZonesRiparianSmall',
};

export default {
	interferometryPoints,
	interferometryPointsSmall,
	interferometryZones,
	interferometryZonesSmall,
	zones,
	zonesSmall,
	zonesCoastal,
	interferometryZonesCoastal,
	zonesCoastalSmall,
	interferometryZonesCoastalSmall,
	zonesRiparian,
	interferometryZonesRiparian,
	zonesRiparianSmall,
	interferometryZonesRiparianSmall,
};
